import { render } from "./FooterBar.vue?vue&type=template&id=27020efc&scoped=true"
const script = {}

import "./FooterBar.vue?vue&type=style&index=0&id=27020efc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27020efc"]])

export default __exports__